import React from 'react';

const Footer_m =() => {
    return <div>
        <footer class=" brown darken-4 page-footer">
          <div class="container">
            <div class="row">
              <div class="center">
                <h5 class="white-text">Contact</h5>
                <ul>

                
                <li><a class="grey-text text-lighten-3" href="#!">Phone: 702-366-4826 </a></li>
                  <li><a class="grey-text text-lighten-3" href="#!">Email: Progressconcrete@gmail.com </a></li>
                </ul>

                <p class="grey-text text-lighten-4">Contact us for a free quote!</p>
              </div>
              <div class="col l4 offset-l2 s12">
                {/* <h5 class="white-text">Links</h5> */}
                {/* <ul>
                  <li><a class="grey-text text-lighten-3" href="#!">Phone: 702-366-4826 </a></li>
                  <li><a class="grey-text text-lighten-3" href="#!">Email: Progressconcrete@gmail.com </a></li>
                </ul> */}
              </div>
            </div>
          </div>
          <div class="footer-copyright">
            <div class="container">
            © 2021 All rights reserved

            </div>
          </div>
        </footer>


    </div>

}

export default Footer_m;